import { Feature } from '.generated/templates/Feature.Items.model';
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames';
// Components
import Container from 'components/helpers/Container/Container';
import ModalStandard from 'components/helpers/Modals/ModalStandard/ModalStandard';
import PlaceholderWrapper from 'components/helpers/PlaceholderWrapper/PlaceholderWrapper';
import useExperienceEditor from 'lib/sitecore/use-experience-editor';
import EditingHelpText, { MissingDataSource } from 'components/helpers/EditingHelpText';
import { useState } from 'react';

export type ModalContainerProps = {
  fields: Sitecore.Override.ItemEx &
    Feature.Components.General.Fields.ModalContainer & {
      dataSourceItemId: string;
    };
  rendering: ComponentRendering;
};

//Sitecore.Override.ComponentBase &
const ModalContainer = ({ fields, rendering }: ModalContainerProps): JSX.Element => {
  if (!fields) {
    return <MissingDataSource />;
  }

  const isEE = useExperienceEditor();
  const [showModal, setShowModal] = useState(false);
  const placeholderModalContainer = (
    <PlaceholderWrapper
      wrapperSize="two-thirds"
      displayName="BCBSAZ-Modal-Container"
      name="BCBSAZ-Modal-Container"
      rendering={rendering}
    />
  );

  return (
    <Container dataComponent="authorable/general/modalcontainer">
      <>
        {!isEE ? (
          <>
            <a
              className={classNames('hidden')}
              data-modal-target-id={fields?.dataSourceItemId}
              onClick={(e) => {
                e.preventDefault();
                setShowModal(true);
              }}
            ></a>
            <ModalStandard externalTrigger showModal={showModal} handleModal={setShowModal}>
              {placeholderModalContainer}
            </ModalStandard>
          </>
        ) : (
          <>
            <EditingHelpText
              condition={true}
              text="To use this modal, click insert item on a general link field and set it to this
              datasource."
            />
            {placeholderModalContainer}
          </>
        )}
      </>
    </Container>
  );
};

export default ModalContainer;
